/* src/app/features/contratacao/questionario-fgenergia/questionario-fgenergia-listagem/questionario-fgenergia-listagem.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=questionario-fgenergia-listagem.component.css.map */
